import classnames from 'classnames'
import PropTypes from 'prop-types'
import { Table, sortColumn } from 'reactabular'
import moment from 'moment'
import IconSVG from 'svg-inline-react'

import ReplyEditDropDown from 'components/settings/reply/ReplyEditDropDown'
import { stripHTMLFromText } from 'shared-web/src/helpers/StripHTMLFromText'

import 'styles/components/settings/reply/ReplyTable.styl'

const ReplyTable = React.createClass({

  contextTypes: {
    router: PropTypes.object.isRequired
  },

  onReplyClick(reply) {
    if (!this.state.selectedReplyToEdit) {
      const path = `/settings/replies/compose/${ reply.id }`
      return this.context.router.push(path)
    }
  },

  onEditOptionsClick(reply, event) {
    event.stopPropagation()
    return this.setState({
      selectedReplyToEdit: reply
    })
  },

  onDeleteReply(replyId) {
    this.props.onDeleteReply(replyId)
    return this.setState({ selectedReplyToEdit: null })
  },

  renderEditDropDownForReply(reply) {
    return (
      <ReplyEditDropDown
        replyId={reply.id}
        onClickOutside={() => this.setState({ selectedReplyToEdit: false })}
        onDelete={this.onDeleteReply.bind(this)} />
    )
  },

  getColumns() {
    return [
      {
        property: 'name',
        header: 'Preview',
        cell(value, data, rowIndex) {
          const reply = data[rowIndex]
          return (
            <div className="preview">
              <div className="name">
                {reply.name}
              </div>
              <div
                className="text"
                dangerouslySetInnerHTML={{ __html: stripHTMLFromText(reply.text) }} />
            </div>
          )
        }
      },
      // TODO add tags when ready
      {
        property: 'updatedAt',
        header: 'Last Used',
        cell(value) {
          return (
            <div className="last-used">
              {moment(value).fromNow()}
            </div>
          )
        }
      },
      {
        cell: (value, data, rowIndex) => {
          const reply = data[rowIndex]
          const isSelected = this.state.selectedReplyToEdit === reply
          return (
            <div className={classnames('edit', { selected: isSelected })}>
              <IconSVG
                className="ignore-react-onclickoutside"
                src={require('!svg-inline?removeTags=true!images/icons/cog-fill-icon.svg')}
                onClick={this.onEditOptionsClick.bind(this, reply)} />
              {isSelected ? this.renderEditDropDownForReply(reply) : undefined}
            </div>
          )
        }
      }
    ]
  },

  getHeader() {
    return {
      onClick: column => {
        return sortColumn(this.state.columns, column, this.setState.bind(this))
      }
    }
  },

  getInitialState() {
    return {
      columns: this.getColumns(),
      header: this.getHeader()
    }
  },

  render() {
    const data = sortColumn.sort(this.props.replies, this.state.sortingColumn, _.orderBy)
    return (
      <div className="ReplyTable">
        <Table
          columns={this.state.columns}
          data={data}
          columnNames={this.state.header}
          row={reply => {
            return {
              onClick: this.onReplyClick.bind(this, reply)
            }
          }} />
      </div>
    )
  }

})

export default ReplyTable



// WEBPACK FOOTER //
// ./src/scripts/components/settings/reply/ReplyTable.js